var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconControls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-controls") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Security",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-842.000000, -3751.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(339.000000, 3491.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(0.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy-7",
    transform: "translate(482.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-controls",
    transform: "translate(21.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,9 C14.746875,9 15.75,10.003125 15.75,11.25 L15.75,14.25 L17.25,14.25 C18.496875,14.25 19.5,15.253125 19.5,16.5 C19.5,17.746875 18.496875,18.75 17.25,18.75 L15.75,18.75 L15.75,30.75 C15.75,31.996875 14.746875,33 13.5,33 C12.253125,33 11.25,31.996875 11.25,30.75 L11.25,18.75 L9.75,18.75 C8.5078125,18.75 7.5,17.746875 7.5,16.5 C7.5,15.253125 8.5078125,14.25 9.75,14.25 L11.25,14.25 L11.25,11.25 C11.25,10.003125 12.253125,9 13.5,9 Z M30.75,23.25 L32.25,23.25 C33.496875,23.25 34.5,24.253125 34.5,25.5 C34.5,26.746875 33.496875,27.75 32.25,27.75 L30.75,27.75 L30.75,30.75 C30.75,31.996875 29.746875,33 28.5,33 C27.253125,33 26.25,31.996875 26.25,30.75 L26.25,27.75 L24.75,27.75 C23.503125,27.75 22.5,26.746875 22.5,25.5 C22.5,24.253125 23.503125,23.25 24.75,23.25 L26.25,23.25 L26.25,11.25 C26.25,10.003125 27.253125,9 28.5,9 C29.746875,9 30.75,10.003125 30.75,11.25 L30.75,23.25 Z M36,0 C39.309375,0 42,2.6859375 42,6 L42,36 C42,39.309375 39.309375,42 36,42 L6,42 C2.6859375,42 0,39.309375 0,36 L0,6 C0,2.6859375 2.6859375,0 6,0 L36,0 Z M36,4.5 L6,4.5 C5.17125,4.5 4.5,5.17125 4.5,6 L4.5,36 C4.5,36.825 5.17125,37.5 6,37.5 L36,37.5 C36.825,37.5 37.5,36.825 37.5,36 L37.5,6 C37.5,5.17125 36.825,4.5 36,4.5 Z",
    id: "Shape"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconControls);
export default __webpack_public_path__ + "static/media/icon-controls.65b79762adaa6823bd024d8d6b086ad9.svg";
export { ForwardRef as ReactComponent };